<template>
  <div id="app">
    <main-menu />
    <router-view v-if="loaded" />
    <div v-else>Loading...</div>
  </div>
</template>

<script>
import MainMenu from '@/components/MainMenu'

export default {
  components: { MainMenu },
  data () {
    return {
      loaded: false,
    }
  },
  created () {
    this.$store.dispatch('loadMaps')
      .then(() => this.loaded = true)
  },
}
</script>

<style lang="scss">
@import "stylesheets/app";
</style>
